import { IMicrofrontendManifest } from '@cian/mf-registry/shared';
import { ModalWindow } from '@cian/ui-kit';
import * as React from 'react';

import { ComplaintModalContent } from '../ComplaintModalContent';

export interface IComplaintProps {
  offerId: number;
  isError: boolean;
  manifest: IMicrofrontendManifest | null;
  openModal: boolean;

  onCloseModal(): void;
  getComplaints(): void;
}

export const ComplaintModal: React.FC<IComplaintProps> = props => {
  const { onCloseModal, openModal } = props;

  return (
    <ModalWindow
      size="XS"
      width={600}
      open={openModal}
      onClose={onCloseModal}
      content={openModal && <ComplaintModalContent {...props} />}
    />
  );
};
